import type { NavSection } from "@/components/feature/Sidebar";

// ══════════════════════════════════════════════════════
// ROLES
// ══════════════════════════════════════════════════════
export interface Role {
  id: string;
  nombre: string;
  descripcion: string;
  activo: boolean;
}

export const ROLES: Role[] = [
  { id: "director", nombre: "Director", descripcion: "Acceso transversal a todos los módulos, dashboards, reportes e indicadores de gestión", activo: true },
  { id: "convivencia", nombre: "Encargado de Convivencia Escolar", descripcion: "Gestión de casos de convivencia, intervenciones, seguimientos, medidas y acuerdos", activo: true },
  { id: "orientador", nombre: "Orientador/a", descripcion: "Casos de orientación, judicializados, informes para tribunal, insumos docentes", activo: true },
  { id: "psicologo", nombre: "Psicólogo/a", descripcion: "Casos psicológicos, intervenciones, seguimiento individual, registros confidenciales", activo: true },
  { id: "inspector", nombre: "Inspector General", descripcion: "Casos de convivencia asignados, incidentes, protocolos, derivaciones", activo: true },
  { id: "profesor_jefe", nombre: "Profesor Jefe", descripcion: "Solicitudes de insumos, estudiantes del curso, formularios, alertas de plazo", activo: true },
  { id: "docente", nombre: "Docente", descripcion: "Bandeja de solicitudes, formularios asignados, respuestas enviadas", activo: true },
  { id: "admin", nombre: "Administrador del Sistema", descripcion: "Usuarios, roles, documentos, configuración, auditoría, logs", activo: true },
  { id: "sostenedor", nombre: "Sostenedor / Equipo Directivo Superior", descripcion: "Visión institucional global, reportes consolidados, indicadores de gestión", activo: true },
];

// ══════════════════════════════════════════════════════
// PERMISSIONS
// ══════════════════════════════════════════════════════
export interface Permission {
  id: string;
  codigo: string;
  descripcion: string;
  modulo: string;
}

export const PERMISSIONS: Permission[] = [
  { id: "p1", codigo: "ver_dashboard_general", descripcion: "Ver dashboard general / resumen ejecutivo", modulo: "resumen" },
  { id: "p2", codigo: "ver_dashboard_convivencia", descripcion: "Ver dashboard de convivencia escolar", modulo: "convivencia" },
  { id: "p3", codigo: "ver_dashboard_orientacion", descripcion: "Ver dashboard de orientación", modulo: "orientacion" },
  { id: "p4", codigo: "ver_dashboard_psicologo", descripcion: "Ver dashboard de psicólogo", modulo: "psicologo" },
  { id: "p5", codigo: "ver_dashboard_inspector", descripcion: "Ver dashboard de inspectoría", modulo: "inspector" },
  { id: "p6", codigo: "ver_casos_convivencia", descripcion: "Ver casos de convivencia", modulo: "convivencia" },
  { id: "p7", codigo: "ver_casos_orientacion", descripcion: "Ver casos de orientación", modulo: "orientacion" },
  { id: "p8", codigo: "ver_casos_psicologicos", descripcion: "Ver casos psicológicos", modulo: "psicologo" },
  { id: "p9", codigo: "ver_casos_judicializados", descripcion: "Ver casos judicializados", modulo: "orientacion" },
  { id: "p10", codigo: "ver_casos_asignados", descripcion: "Ver solo casos asignados", modulo: "general" },
  { id: "p11", codigo: "ver_casos_todos", descripcion: "Ver todos los casos", modulo: "general" },
  { id: "p12", codigo: "crear_caso_convivencia", descripcion: "Crear caso de convivencia", modulo: "convivencia" },
  { id: "p13", codigo: "crear_caso_orientacion", descripcion: "Crear caso de orientación", modulo: "orientacion" },
  { id: "p14", codigo: "crear_incidente", descripcion: "Crear incidente / registro de hecho", modulo: "inspector" },
  { id: "p15", codigo: "editar_caso", descripcion: "Editar casos", modulo: "general" },
  { id: "p16", codigo: "cerrar_caso", descripcion: "Cerrar casos", modulo: "general" },
  { id: "p17", codigo: "reabrir_caso", descripcion: "Reabrir casos", modulo: "general" },
  { id: "p18", codigo: "registrar_intervencion_convivencia", descripcion: "Registrar intervención de convivencia", modulo: "convivencia" },
  { id: "p19", codigo: "registrar_intervencion_psicologica", descripcion: "Registrar intervención psicológica", modulo: "psicologo" },
  { id: "p20", codigo: "registrar_intervencion_orientacion", descripcion: "Registrar intervención de orientación", modulo: "orientacion" },
  { id: "p21", codigo: "ver_intervenciones", descripcion: "Ver intervenciones", modulo: "general" },
  { id: "p22", codigo: "ver_intervenciones_confidenciales", descripcion: "Ver intervenciones confidenciales", modulo: "psicologo" },
  { id: "p23", codigo: "solicitar_insumos", descripcion: "Solicitar insumos a docentes", modulo: "orientacion" },
  { id: "p24", codigo: "responder_insumos", descripcion: "Responder solicitudes de insumos", modulo: "docente" },
  { id: "p25", codigo: "ver_insumos_pendientes", descripcion: "Ver insumos pendientes", modulo: "orientacion" },
  { id: "p26", codigo: "generar_informe_ia", descripcion: "Generar informes con IA", modulo: "ia" },
  { id: "p27", codigo: "aprobar_informe", descripcion: "Aprobar informes", modulo: "orientacion" },
  { id: "p28", codigo: "enviar_informe_tribunal", descripcion: "Enviar informes a tribunal", modulo: "orientacion" },
  { id: "p29", codigo: "descargar_reportes_area", descripcion: "Descargar reportes del área", modulo: "reportes" },
  { id: "p30", codigo: "descargar_reportes_institucionales", descripcion: "Descargar reportes institucionales (Director)", modulo: "reportes" },
  { id: "p31", codigo: "ver_reportes_area", descripcion: "Ver reportes del área", modulo: "reportes" },
  { id: "p32", codigo: "ver_reportes_institucionales", descripcion: "Ver reportes institucionales", modulo: "reportes" },
  { id: "p33", codigo: "administrar_usuarios", descripcion: "Administrar usuarios y roles", modulo: "admin" },
  { id: "p34", codigo: "administrar_documentos", descripcion: "Administrar documentos institucionales", modulo: "admin" },
  { id: "p35", codigo: "ver_auditoria", descripcion: "Ver auditoría y logs", modulo: "admin" },
  { id: "p36", codigo: "consultar_ia", descripcion: "Consultar asistente IA", modulo: "ia" },
  { id: "p37", codigo: "gestionar_protocolos", descripcion: "Gestionar protocolos y reglamentos", modulo: "admin" },
  { id: "p38", codigo: "ver_expedientes", descripcion: "Ver expedientes de estudiantes", modulo: "general" },
  { id: "p39", codigo: "ver_calendario", descripcion: "Ver calendario", modulo: "general" },
  { id: "p40", codigo: "ver_alertas", descripcion: "Ver alertas", modulo: "general" },
  { id: "p41", codigo: "gestionar_medidas", descripcion: "Gestionar medidas y acuerdos", modulo: "convivencia" },
  { id: "p42", codigo: "realizar_derivacion_interna", descripcion: "Realizar derivaciones internas", modulo: "general" },
  { id: "p43", codigo: "realizar_derivacion_externa", descripcion: "Realizar derivaciones externas", modulo: "psicologo" },
  { id: "p44", codigo: "ver_registro_confidencial", descripcion: "Ver registro confidencial psicológico", modulo: "psicologo" },
  { id: "p45", codigo: "ver_estudiantes_curso", descripcion: "Ver estudiantes de su curso", modulo: "profesor_jefe" },
  { id: "p46", codigo: "completar_formulario_docente", descripcion: "Completar formularios de antecedentes", modulo: "docente" },
  { id: "p47", codigo: "ver_configuracion", descripcion: "Ver configuración del sistema", modulo: "admin" },
];

// ══════════════════════════════════════════════════════
// ROLE-PERMISSION MAPPINGS
// ══════════════════════════════════════════════════════
export interface RolePermission {
  role_id: string;
  permission_id: string;
}

export const ROLE_PERMISSIONS: RolePermission[] = [
  // ── Director: acceso completo ──
  { role_id: "director", permission_id: "ver_dashboard_general" },
  { role_id: "director", permission_id: "ver_dashboard_convivencia" },
  { role_id: "director", permission_id: "ver_dashboard_orientacion" },
  { role_id: "director", permission_id: "ver_dashboard_psicologo" },
  { role_id: "director", permission_id: "ver_casos_convivencia" },
  { role_id: "director", permission_id: "ver_casos_orientacion" },
  { role_id: "director", permission_id: "ver_casos_psicologicos" },
  { role_id: "director", permission_id: "ver_casos_judicializados" },
  { role_id: "director", permission_id: "ver_casos_todos" },
  { role_id: "director", permission_id: "ver_intervenciones" },
  { role_id: "director", permission_id: "ver_insumos_pendientes" },
  { role_id: "director", permission_id: "ver_expedientes" },
  { role_id: "director", permission_id: "ver_calendario" },
  { role_id: "director", permission_id: "ver_alertas" },
  { role_id: "director", permission_id: "descargar_reportes_institucionales" },
  { role_id: "director", permission_id: "ver_reportes_institucionales" },
  { role_id: "director", permission_id: "consultar_ia" },
  { role_id: "director", permission_id: "ver_auditoria" },

  // ── Encargado de Convivencia ──
  { role_id: "convivencia", permission_id: "ver_dashboard_general" },
  { role_id: "convivencia", permission_id: "ver_dashboard_convivencia" },
  { role_id: "convivencia", permission_id: "ver_casos_convivencia" },
  { role_id: "convivencia", permission_id: "ver_casos_asignados" },
  { role_id: "convivencia", permission_id: "crear_caso_convivencia" },
  { role_id: "convivencia", permission_id: "editar_caso" },
  { role_id: "convivencia", permission_id: "cerrar_caso" },
  { role_id: "convivencia", permission_id: "registrar_intervencion_convivencia" },
  { role_id: "convivencia", permission_id: "ver_intervenciones" },
  { role_id: "convivencia", permission_id: "ver_expedientes" },
  { role_id: "convivencia", permission_id: "ver_calendario" },
  { role_id: "convivencia", permission_id: "ver_alertas" },
  { role_id: "convivencia", permission_id: "gestionar_medidas" },
  { role_id: "convivencia", permission_id: "realizar_derivacion_interna" },
  { role_id: "convivencia", permission_id: "descargar_reportes_area" },
  { role_id: "convivencia", permission_id: "ver_reportes_area" },
  { role_id: "convivencia", permission_id: "consultar_ia" },

  // ── Orientador/a ──
  { role_id: "orientador", permission_id: "ver_dashboard_general" },
  { role_id: "orientador", permission_id: "ver_dashboard_orientacion" },
  { role_id: "orientador", permission_id: "ver_casos_orientacion" },
  { role_id: "orientador", permission_id: "ver_casos_judicializados" },
  { role_id: "orientador", permission_id: "ver_casos_asignados" },
  { role_id: "orientador", permission_id: "crear_caso_orientacion" },
  { role_id: "orientador", permission_id: "editar_caso" },
  { role_id: "orientador", permission_id: "registrar_intervencion_orientacion" },
  { role_id: "orientador", permission_id: "ver_intervenciones" },
  { role_id: "orientador", permission_id: "solicitar_insumos" },
  { role_id: "orientador", permission_id: "ver_insumos_pendientes" },
  { role_id: "orientador", permission_id: "generar_informe_ia" },
  { role_id: "orientador", permission_id: "aprobar_informe" },
  { role_id: "orientador", permission_id: "enviar_informe_tribunal" },
  { role_id: "orientador", permission_id: "ver_expedientes" },
  { role_id: "orientador", permission_id: "ver_calendario" },
  { role_id: "orientador", permission_id: "ver_alertas" },
  { role_id: "orientador", permission_id: "realizar_derivacion_interna" },
  { role_id: "orientador", permission_id: "descargar_reportes_area" },
  { role_id: "orientador", permission_id: "ver_reportes_area" },
  { role_id: "orientador", permission_id: "consultar_ia" },

  // ── Psicólogo/a ──
  { role_id: "psicologo", permission_id: "ver_dashboard_general" },
  { role_id: "psicologo", permission_id: "ver_dashboard_psicologo" },
  { role_id: "psicologo", permission_id: "ver_casos_psicologicos" },
  { role_id: "psicologo", permission_id: "ver_casos_asignados" },
  { role_id: "psicologo", permission_id: "registrar_intervencion_psicologica" },
  { role_id: "psicologo", permission_id: "ver_intervenciones" },
  { role_id: "psicologo", permission_id: "ver_intervenciones_confidenciales" },
  { role_id: "psicologo", permission_id: "ver_registro_confidencial" },
  { role_id: "psicologo", permission_id: "realizar_derivacion_interna" },
  { role_id: "psicologo", permission_id: "realizar_derivacion_externa" },
  { role_id: "psicologo", permission_id: "ver_expedientes" },
  { role_id: "psicologo", permission_id: "ver_calendario" },
  { role_id: "psicologo", permission_id: "ver_alertas" },
  { role_id: "psicologo", permission_id: "generar_informe_ia" },
  { role_id: "psicologo", permission_id: "descargar_reportes_area" },
  { role_id: "psicologo", permission_id: "ver_reportes_area" },
  { role_id: "psicologo", permission_id: "consultar_ia" },

  // ── Inspector General ──
  { role_id: "inspector", permission_id: "ver_dashboard_general" },
  { role_id: "inspector", permission_id: "ver_dashboard_convivencia" },
  { role_id: "inspector", permission_id: "ver_casos_convivencia" },
  { role_id: "inspector", permission_id: "ver_casos_asignados" },
  { role_id: "inspector", permission_id: "crear_caso_convivencia" },
  { role_id: "inspector", permission_id: "crear_incidente" },
  { role_id: "inspector", permission_id: "registrar_intervencion_convivencia" },
  { role_id: "inspector", permission_id: "ver_intervenciones" },
  { role_id: "inspector", permission_id: "realizar_derivacion_interna" },
  { role_id: "inspector", permission_id: "ver_calendario" },
  { role_id: "inspector", permission_id: "ver_alertas" },
  { role_id: "inspector", permission_id: "consultar_ia" },

  // ── Profesor Jefe ──
  { role_id: "profesor_jefe", permission_id: "ver_dashboard_general" },
  { role_id: "profesor_jefe", permission_id: "responder_insumos" },
  { role_id: "profesor_jefe", permission_id: "completar_formulario_docente" },
  { role_id: "profesor_jefe", permission_id: "ver_estudiantes_curso" },
  { role_id: "profesor_jefe", permission_id: "ver_calendario" },
  { role_id: "profesor_jefe", permission_id: "ver_alertas" },
  { role_id: "profesor_jefe", permission_id: "consultar_ia" },

  // ── Docente ──
  { role_id: "docente", permission_id: "ver_dashboard_general" },
  { role_id: "docente", permission_id: "responder_insumos" },
  { role_id: "docente", permission_id: "completar_formulario_docente" },
  { role_id: "docente", permission_id: "consultar_ia" },

  // ── Administrador ──
  { role_id: "admin", permission_id: "ver_dashboard_general" },
  { role_id: "admin", permission_id: "administrar_usuarios" },
  { role_id: "admin", permission_id: "administrar_documentos" },
  { role_id: "admin", permission_id: "ver_auditoria" },
  { role_id: "admin", permission_id: "ver_configuracion" },
  { role_id: "admin", permission_id: "gestionar_protocolos" },

  // ── Sostenedor ──
  { role_id: "sostenedor", permission_id: "ver_dashboard_general" },
  { role_id: "sostenedor", permission_id: "ver_dashboard_convivencia" },
  { role_id: "sostenedor", permission_id: "ver_dashboard_orientacion" },
  { role_id: "sostenedor", permission_id: "ver_dashboard_psicologo" },
  { role_id: "sostenedor", permission_id: "ver_casos_todos" },
  { role_id: "sostenedor", permission_id: "ver_reportes_institucionales" },
  { role_id: "sostenedor", permission_id: "descargar_reportes_institucionales" },
];

// ══════════════════════════════════════════════════════
// USER-ROLE ASSIGNMENTS
// ══════════════════════════════════════════════════════
export interface UserRole {
  user_id: string;
  role_id: string;
  tenant_id: string;
}

export const USER_ROLES: UserRole[] = [
  { user_id: "u1", role_id: "admin", tenant_id: "t1" },
  { user_id: "u2", role_id: "inspector", tenant_id: "t1" },
  { user_id: "u3", role_id: "profesor_jefe", tenant_id: "t1" },
  { user_id: "u4", role_id: "orientador", tenant_id: "t1" },
  { user_id: "u5", role_id: "director", tenant_id: "t1" },
  { user_id: "u6", role_id: "admin", tenant_id: "saas" },
  { user_id: "u7", role_id: "profesor_jefe", tenant_id: "t1" },
  { user_id: "u8", role_id: "profesor_jefe", tenant_id: "t1" },
  { user_id: "u9", role_id: "profesor_jefe", tenant_id: "t1" },
  { user_id: "u10", role_id: "psicologo", tenant_id: "t1" },
  { user_id: "u11", role_id: "convivencia", tenant_id: "t1" },
  { user_id: "u12", role_id: "docente", tenant_id: "t1" },
  { user_id: "u13", role_id: "sostenedor", tenant_id: "t1" },
];

// ══════════════════════════════════════════════════════
// PERMISSION CHECK UTILITY
// ══════════════════════════════════════════════════════
export function hasPermission(userRol: string, permissionCode: string): boolean {
  const rolePerms = ROLE_PERMISSIONS.filter((rp) => rp.role_id === userRol);
  return rolePerms.some((rp) => rp.permission_id === permissionCode);
}

export function getRolePermissions(userRol: string): string[] {
  return ROLE_PERMISSIONS.filter((rp) => rp.role_id === userRol).map((rp) => rp.permission_id);
}

export function getRoleInfo(roleId: string): Role | undefined {
  return ROLES.find((r) => r.id === roleId);
}

export function getRoleLabel(roleId: string): string {
  const role = ROLES.find((r) => r.id === roleId);
  return role?.nombre || roleId;
}

// ══════════════════════════════════════════════════════
// ROLE-BASED NAVIGATION SECTIONS
// ══════════════════════════════════════════════════════
// Each role gets its own navigation structure

interface RoleNavSection {
  title: string;
  icon: string;
  items: { label: string; icon: string; path: string; badge?: string; badgeColor?: "red" | "amber" | "green" | "neutral" }[];
  moduleColor?: "primary" | "accent" | "secondary" | "green" | "purple" | "foreground";
  defaultOpen?: boolean;
}

// ── DIRECTOR ──
const DIRECTOR_NAV: RoleNavSection[] = [
  {
    title: "Resumen Ejecutivo",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Panel General", icon: "ri-dashboard-line", path: "/director" },
      { label: "Indicadores Clave", icon: "ri-bar-chart-2-line", path: "/director/indicadores" },
      { label: "Alertas Críticas", icon: "ri-alert-line", path: "/director/alertas", badge: "8", badgeColor: "red" },
      { label: "Casos Prioritarios", icon: "ri-flag-2-line", path: "/director/prioritarios", badge: "4", badgeColor: "red" },
    ],
  },
  {
    title: "Gestión de Convivencia Escolar",
    icon: "ri-shield-user-line",
    moduleColor: "primary",
    defaultOpen: false,
    items: [
      { label: "Dashboard de Convivencia", icon: "ri-dashboard-3-line", path: "/convivencia" },
      { label: "Casos de Convivencia", icon: "ri-folder-3-line", path: "/convivencia/casos", badge: "6", badgeColor: "neutral" },
      { label: "Seguimientos", icon: "ri-line-chart-line", path: "/convivencia/seguimientos" },
      { label: "Expedientes", icon: "ri-user-search-line", path: "/convivencia/expedientes" },
      { label: "Medidas y Acuerdos", icon: "ri-hand-heart-line", path: "/convivencia/medidas" },
    ],
  },
  {
    title: "Gestión de Orientación",
    icon: "ri-compass-3-line",
    moduleColor: "secondary",
    defaultOpen: false,
    items: [
      { label: "Dashboard de Orientación", icon: "ri-dashboard-3-line", path: "/orientacion" },
      { label: "Casos de Orientación", icon: "ri-folder-3-line", path: "/orientacion/casos" },
      { label: "Casos Judicializados", icon: "ri-scales-3-line", path: "/orientacion/judicializados", badge: "2", badgeColor: "red" },
      { label: "Informes para Tribunal", icon: "ri-file-warning-line", path: "/orientacion/informes", badge: "1", badgeColor: "amber" },
      { label: "Insumos Docentes", icon: "ri-send-plane-line", path: "/orientacion/insumos" },
    ],
  },
  {
    title: "Requerimientos Judiciales",
    icon: "ri-scales-3-line",
    moduleColor: "purple",
    defaultOpen: false,
    items: [
      { label: "Dashboard Judicial", icon: "ri-dashboard-3-line", path: "/judicial" },
      { label: "Todos los Requerimientos", icon: "ri-folder-3-line", path: "/judicial/requerimientos", badge: "10", badgeColor: "neutral" },
      { label: "Nuevo Requerimiento", icon: "ri-add-circle-line", path: "/judicial/nuevo" },
      { label: "Informes Generados", icon: "ri-file-chart-line", path: "/judicial/informes", badge: "2", badgeColor: "green" },
      { label: "Requerimientos Vencidos", icon: "ri-error-warning-line", path: "/judicial/requerimientos?estado=vencido", badge: "1", badgeColor: "red" },
    ],
  },
  {
    title: "Gestión Psicólogo",
    icon: "ri-psychotherapy-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Dashboard Psicólogo", icon: "ri-dashboard-3-line", path: "/psicologo" },
      { label: "Casos Psicológicos", icon: "ri-folder-3-line", path: "/psicologo/casos" },
      { label: "Seguimiento Individual", icon: "ri-user-heart-line", path: "/psicologo/seguimiento" },
      { label: "Informes Psicoeducativos", icon: "ri-file-text-line", path: "/psicologo/informes" },
    ],
  },
  {
    title: "Reportes y Desempeño",
    icon: "ri-file-chart-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Reporte Convivencia", icon: "ri-file-text-line", path: "/director/reportes/convivencia" },
      { label: "Reporte Orientación", icon: "ri-file-text-line", path: "/director/reportes/orientacion" },
      { label: "Reporte Psicología", icon: "ri-file-text-line", path: "/director/reportes/psicologia" },
      { label: "Reporte Judicializados", icon: "ri-scales-3-line", path: "/director/reportes/judicializados" },
      { label: "Desempeño por Responsable", icon: "ri-team-line", path: "/director/reportes/desempeno" },
      { label: "Reporte Consolidado", icon: "ri-bar-chart-box-line", path: "/director/reportes/consolidado" },
    ],
  },
  {
    title: "Asistente IA",
    icon: "ri-robot-2-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Consulta Rápida", icon: "ri-chat-3-line", path: "/ia/consulta" },
      { label: "Protocolos de Actuación", icon: "ri-book-open-line", path: "/ia/protocolos" },
      { label: "Normativa Nacional", icon: "ri-government-line", path: "/ia/normativa" },
    ],
  },
  {
    title: "Administración",
    icon: "ri-settings-3-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Usuarios y Roles", icon: "ri-team-line", path: "/admin/usuarios" },
      { label: "Auditoría", icon: "ri-shield-check-line", path: "/admin/auditoria" },
      { label: "Configuración", icon: "ri-settings-4-line", path: "/admin/configuracion" },
    ],
  },
];

// ── ENCARGADO DE CONVIVENCIA ──
const CONVIVENCIA_NAV: RoleNavSection[] = [
  {
    title: "Dashboard Convivencia",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Panel de Convivencia", icon: "ri-shield-user-line", path: "/convivencia" },
      { label: "Indicadores", icon: "ri-bar-chart-2-line", path: "/resumen/indicadores" },
      { label: "Alertas", icon: "ri-alert-line", path: "/convivencia/alertas", badge: "3", badgeColor: "red" },
      { label: "Calendario", icon: "ri-calendar-event-line", path: "/convivencia/calendario" },
    ],
  },
  {
    title: "Gestión de Convivencia Escolar",
    icon: "ri-shield-user-line",
    moduleColor: "primary",
    defaultOpen: false,
    items: [
      { label: "Casos de Convivencia", icon: "ri-folder-3-line", path: "/convivencia/casos", badge: "6", badgeColor: "neutral" },
      { label: "Crear Caso", icon: "ri-add-circle-line", path: "/convivencia/casos/nuevo" },
      { label: "Seguimientos", icon: "ri-line-chart-line", path: "/convivencia/seguimientos" },
      { label: "Entrevistas y Actas", icon: "ri-mic-line", path: "/convivencia/entrevistas" },
      { label: "Medidas y Acuerdos", icon: "ri-hand-heart-line", path: "/convivencia/medidas" },
      { label: "Derivaciones", icon: "ri-share-forward-line", path: "/convivencia/derivaciones" },
      { label: "Expedientes", icon: "ri-user-search-line", path: "/convivencia/expedientes" },
      { label: "Informes de Convivencia", icon: "ri-file-chart-line", path: "/convivencia/informes", badge: "1", badgeColor: "amber" },
    ],
  },
  {
    title: "Asistente IA",
    icon: "ri-robot-2-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Consulta Rápida", icon: "ri-chat-3-line", path: "/ia/consulta" },
      { label: "Protocolos de Actuación", icon: "ri-book-open-line", path: "/ia/protocolos" },
      { label: "Lectura Guiada", icon: "ri-book-read-line", path: "/ia/lectura" },
    ],
  },
];

// ── ORIENTADOR/A ──
const ORIENTADOR_NAV: RoleNavSection[] = [
  {
    title: "Dashboard Orientación",
    icon: "ri-dashboard-3-line",
    moduleColor: "secondary",
    defaultOpen: true,
    items: [
      { label: "Panel de Orientación", icon: "ri-compass-3-line", path: "/orientacion" },
      { label: "Indicadores", icon: "ri-bar-chart-2-line", path: "/resumen/indicadores" },
      { label: "Alertas", icon: "ri-alert-line", path: "/orientacion/alertas" },
      { label: "Calendario", icon: "ri-calendar-event-line", path: "/orientacion/calendario" },
    ],
  },
  {
    title: "Gestión de Orientación",
    icon: "ri-compass-3-line",
    moduleColor: "secondary",
    defaultOpen: false,
    items: [
      { label: "Casos de Orientación", icon: "ri-folder-3-line", path: "/orientacion/casos", badge: "5", badgeColor: "neutral" },
      { label: "Casos Judicializados", icon: "ri-scales-3-line", path: "/orientacion/judicializados", badge: "2", badgeColor: "red" },
      { label: "Informes para Tribunal", icon: "ri-file-warning-line", path: "/orientacion/informes", badge: "1", badgeColor: "amber" },
      { label: "Solicitud de Insumos", icon: "ri-send-plane-line", path: "/orientacion/insumos", badge: "3", badgeColor: "amber" },
      { label: "Insumos Recibidos", icon: "ri-inbox-line", path: "/orientacion/insumos-recibidos" },
      { label: "Seguimientos", icon: "ri-line-chart-line", path: "/orientacion/seguimientos" },
      { label: "Entrevistas", icon: "ri-mic-line", path: "/orientacion/entrevistas" },
      { label: "Expedientes", icon: "ri-user-search-line", path: "/orientacion/expedientes" },
    ],
  },
  {
    title: "Requerimientos Judiciales",
    icon: "ri-scales-3-line",
    moduleColor: "purple",
    defaultOpen: false,
    items: [
      { label: "Dashboard Judicial", icon: "ri-dashboard-3-line", path: "/judicial" },
      { label: "Todos los Requerimientos", icon: "ri-folder-3-line", path: "/judicial/requerimientos", badge: "10", badgeColor: "neutral" },
      { label: "Nuevo Requerimiento", icon: "ri-add-circle-line", path: "/judicial/nuevo" },
      { label: "Informes Generados", icon: "ri-file-chart-line", path: "/judicial/informes", badge: "2", badgeColor: "green" },
      { label: "Requerimientos Vencidos", icon: "ri-error-warning-line", path: "/judicial/requerimientos?estado=vencido", badge: "1", badgeColor: "red" },
    ],
  },
  {
    title: "Generador IA",
    icon: "ri-robot-2-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Generar Informe IA", icon: "ri-magic-line", path: "/ia/informe" },
      { label: "Generador de Resumen", icon: "ri-file-copy-line", path: "/ia/resumen" },
      { label: "Consulta Rápida", icon: "ri-chat-3-line", path: "/ia/consulta" },
      { label: "Protocolos", icon: "ri-book-open-line", path: "/ia/protocolos" },
    ],
  },
];

// ── PSICÓLOGO/A ──
const PSICOLOGO_NAV: RoleNavSection[] = [
  {
    title: "Dashboard Psicólogo",
    icon: "ri-dashboard-3-line",
    moduleColor: "accent",
    defaultOpen: true,
    items: [
      { label: "Panel de Psicología", icon: "ri-psychotherapy-line", path: "/psicologo" },
      { label: "Indicadores", icon: "ri-bar-chart-2-line", path: "/resumen/indicadores" },
      { label: "Alertas", icon: "ri-alert-line", path: "/psicologo/alertas" },
      { label: "Calendario", icon: "ri-calendar-event-line", path: "/psicologo/calendario" },
    ],
  },
  {
    title: "Gestión Psicólogo",
    icon: "ri-psychotherapy-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Casos Psicológicos", icon: "ri-folder-3-line", path: "/psicologo/casos", badge: "4", badgeColor: "neutral" },
      { label: "Intervenciones", icon: "ri-heart-pulse-line", path: "/psicologo/intervenciones" },
      { label: "Seguimiento Individual", icon: "ri-user-heart-line", path: "/psicologo/seguimiento" },
      { label: "Entrevistas", icon: "ri-mic-line", path: "/psicologo/entrevistas" },
      { label: "Derivaciones Internas", icon: "ri-arrow-left-right-line", path: "/psicologo/derivaciones-internas" },
      { label: "Derivaciones Externas", icon: "ri-external-link-line", path: "/psicologo/derivaciones-externas" },
      { label: "Expedientes", icon: "ri-user-search-line", path: "/psicologo/expedientes" },
      { label: "Informes Psicoeducativos", icon: "ri-file-text-line", path: "/psicologo/informes", badge: "1", badgeColor: "amber" },
      { label: "Registro Confidencial", icon: "ri-lock-line", path: "/psicologo/confidencial" },
    ],
  },
  {
    title: "Asistente IA",
    icon: "ri-robot-2-line",
    moduleColor: "accent",
    defaultOpen: false,
    items: [
      { label: "Generar Informe IA", icon: "ri-magic-line", path: "/ia/informe" },
      { label: "Consulta Rápida", icon: "ri-chat-3-line", path: "/ia/consulta" },
      { label: "Protocolos", icon: "ri-book-open-line", path: "/ia/protocolos" },
    ],
  },
];

// ── INSPECTOR GENERAL ──
const INSPECTOR_NAV: RoleNavSection[] = [
  {
    title: "Inspectoría",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Panel de Inspectoría", icon: "ri-police-car-line", path: "/inspector" },
      { label: "Alertas", icon: "ri-alert-line", path: "/convivencia/alertas", badge: "2", badgeColor: "red" },
      { label: "Calendario", icon: "ri-calendar-event-line", path: "/convivencia/calendario" },
    ],
  },
  {
    title: "Casos y Registros",
    icon: "ri-folder-3-line",
    moduleColor: "primary",
    defaultOpen: false,
    items: [
      { label: "Casos Asignados", icon: "ri-folder-3-line", path: "/convivencia/casos" },
      { label: "Registrar Incidente", icon: "ri-add-circle-line", path: "/convivencia/casos/nuevo" },
      { label: "Registrar Hechos", icon: "ri-pen-nib-line", path: "/intervenciones/nueva" },
      { label: "Adjuntar Evidencias", icon: "ri-image-add-line", path: "/intervenciones/evidencias" },
    ],
  },
  {
    title: "Normativa y Protocolos",
    icon: "ri-book-open-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Consulta Rápida", icon: "ri-chat-3-line", path: "/ia/consulta" },
      { label: "Protocolos", icon: "ri-book-open-line", path: "/ia/protocolos" },
      { label: "Reglamento", icon: "ri-book-read-line", path: "/ia/lectura" },
      { label: "Medidas Aplicables", icon: "ri-hand-heart-line", path: "/convivencia/medidas" },
      { label: "Derivar a Convivencia", icon: "ri-share-forward-line", path: "/convivencia/derivaciones" },
    ],
  },
];

// ── PROFESOR JEFE ──
const PROFESOR_JEFE_NAV: RoleNavSection[] = [
  {
    title: "Mi Panel",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Panel Principal", icon: "ri-dashboard-line", path: "/profesor-jefe" },
      { label: "Alertas de Plazo", icon: "ri-alert-line", path: "/profesor-jefe/alertas", badge: "2", badgeColor: "amber" },
      { label: "Calendario", icon: "ri-calendar-event-line", path: "/resumen/calendario" },
    ],
  },
  {
    title: "Solicitudes y Formularios",
    icon: "ri-file-list-3-line",
    moduleColor: "secondary",
    defaultOpen: false,
    items: [
      { label: "Solicitudes Pendientes", icon: "ri-inbox-line", path: "/profesor-jefe/solicitudes", badge: "3", badgeColor: "amber" },
      { label: "Formularios de Antecedentes", icon: "ri-file-text-line", path: "/profesor-jefe/formularios" },
      { label: "Historial de Solicitudes", icon: "ri-history-line", path: "/profesor-jefe/historial" },
    ],
  },
  {
    title: "Mis Estudiantes",
    icon: "ri-team-line",
    moduleColor: "green",
    defaultOpen: false,
    items: [
      { label: "Estudiantes del Curso", icon: "ri-user-search-line", path: "/estudiantes" },
      { label: "Con Solicitudes Activas", icon: "ri-user-received-line", path: "/profesor-jefe/estudiantes-activos" },
    ],
  },
  {
    title: "Recursos",
    icon: "ri-book-open-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Consulta de Protocolos", icon: "ri-chat-3-line", path: "/ia/consulta" },
    ],
  },
];

// ── DOCENTE ──
const DOCENTE_NAV: RoleNavSection[] = [
  {
    title: "Inicio Docente",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Mis Solicitudes de Informe", icon: "ri-dashboard-line", path: "/docente" },
      { label: "Todas las Solicitudes", icon: "ri-inbox-line", path: "/docente/solicitudes" },
      { label: "En Desarrollo", icon: "ri-pen-nib-line", path: "/docente/formularios", badge: "1", badgeColor: "amber" },
      { label: "Informes Enviados", icon: "ri-history-line", path: "/docente/historial" },
      { label: "Solicitudes Devueltas", icon: "ri-arrow-go-back-line", path: "/docente/devoluciones" },
    ],
  },
  {
    title: "Recursos",
    icon: "ri-book-open-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Consulta de Protocolos", icon: "ri-chat-3-line", path: "/ia/consulta" },
    ],
  },
];

// ── ADMINISTRADOR ──
const ADMIN_NAV: RoleNavSection[] = [
  {
    title: "Administración",
    icon: "ri-settings-3-line",
    moduleColor: "foreground",
    defaultOpen: true,
    items: [
      { label: "Panel de Admin", icon: "ri-dashboard-line", path: "/resumen" },
      { label: "Usuarios y Roles", icon: "ri-team-line", path: "/admin/usuarios" },
      { label: "Permisos", icon: "ri-shield-keyhole-line", path: "/admin/permisos" },
      { label: "Documentos Institucionales", icon: "ri-file-text-line", path: "/admin/documentos" },
      { label: "Configuración", icon: "ri-settings-4-line", path: "/admin/configuracion" },
      { label: "Auditoría", icon: "ri-shield-check-line", path: "/admin/auditoria" },
      { label: "Historial del Sistema", icon: "ri-history-line", path: "/admin/historial" },
    ],
  },
];

// ── SOSTENEDOR ──
const SOSTENEDOR_NAV: RoleNavSection[] = [
  {
    title: "Visión Institucional",
    icon: "ri-dashboard-3-line",
    moduleColor: "primary",
    defaultOpen: true,
    items: [
      { label: "Panel General", icon: "ri-dashboard-line", path: "/director" },
      { label: "Indicadores Globales", icon: "ri-bar-chart-box-line", path: "/director/indicadores" },
    ],
  },
  {
    title: "Gestión por Área",
    icon: "ri-building-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Convivencia Escolar", icon: "ri-shield-user-line", path: "/convivencia" },
      { label: "Orientación", icon: "ri-compass-3-line", path: "/orientacion" },
      { label: "Psicología", icon: "ri-psychotherapy-line", path: "/psicologo" },
    ],
  },
  {
    title: "Reportes",
    icon: "ri-file-chart-line",
    moduleColor: "foreground",
    defaultOpen: false,
    items: [
      { label: "Reporte Consolidado", icon: "ri-bar-chart-box-line", path: "/director/reportes/consolidado" },
      { label: "Desempeño por Área", icon: "ri-team-line", path: "/director/reportes/desempeno" },
    ],
  },
];

// ── SAAS ADMIN ──
const SAAS_NAV: RoleNavSection[] = [
  {
    title: "Administración SaaS",
    icon: "ri-global-line",
    moduleColor: "foreground",
    defaultOpen: true,
    items: [
      { label: "Colegios", icon: "ri-building-line", path: "/saas/tenants" },
      { label: "Normativa Nacional", icon: "ri-government-line", path: "/saas/normativa" },
    ],
  },
];

// ══════════════════════════════════════════════════════
// GETTER: returns navigation sections for a given role
// ══════════════════════════════════════════════════════
export function getRoleNavigation(roleId: string): RoleNavSection[] {
  switch (roleId) {
    case "director": return DIRECTOR_NAV;
    case "convivencia": return CONVIVENCIA_NAV;
    case "orientador": return ORIENTADOR_NAV;
    case "psicologo": return PSICOLOGO_NAV;
    case "inspector": return INSPECTOR_NAV;
    case "profesor_jefe": return PROFESOR_JEFE_NAV;
    case "docente": return DOCENTE_NAV;
    case "admin": return ADMIN_NAV;
    case "sostenedor": return SOSTENEDOR_NAV;
    case "superadmin":
    case "admin_saas": return SAAS_NAV;
    default: return DIRECTOR_NAV;
  }
}

// Default landing page per role
export function getRoleLandingPath(roleId: string): string {
  switch (roleId) {
    case "director": return "/director";
    case "convivencia": return "/convivencia";
    case "orientador": return "/orientacion";
    case "psicologo": return "/psicologo";
    case "inspector": return "/inspector";
    case "profesor_jefe": return "/profesor-jefe";
    case "docente": return "/docente";
    case "admin": return "/admin";
    case "sostenedor": return "/director";
    case "superadmin":
    case "admin_saas": return "/saas/tenants";
    default: return "/resumen";
  }
}